import merge from 'lodash/merge';
import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {DAY_OF_WEEK_TAB_ITEM_SIZE_PX} from './constants';
import {DayOfWeekTabItemProps} from './DayOfWeekTabItemProps.interface';

export function DayOfWeekTabItem({
  isSelected,
  children,
  className,
  style,
  ...props
}: DayOfWeekTabItemProps) {
  return (
    <div
      className={twMerge(
        'flex cursor-pointer select-none items-center justify-center',
        className
      )}
      style={merge(
        {
          width: DAY_OF_WEEK_TAB_ITEM_SIZE_PX,
          height: DAY_OF_WEEK_TAB_ITEM_SIZE_PX,
          minWidth: DAY_OF_WEEK_TAB_ITEM_SIZE_PX,
        },
        style
      )}
      {...props}
    >
      {isSelected && (
        <div
          className="absolute z-30 rounded-full bg-theme-solid-20"
          style={{
            width: DAY_OF_WEEK_TAB_ITEM_SIZE_PX,
            height: DAY_OF_WEEK_TAB_ITEM_SIZE_PX,
            minWidth: DAY_OF_WEEK_TAB_ITEM_SIZE_PX,
          }}
        />
      )}
      <Text
        className={twMerge(
          'z-20',
          isSelected
            ? 'font-small1-bold z-30 text-theme-solid-100'
            : 'font-small1 text-theme-solid-60'
        )}
      >
        {children}
      </Text>
    </div>
  );
}
